import moment from 'moment';
const defaultFormat = 'YYYY-MM-DD';
const defaultMinDate = format => moment('1970-01-01').format(format);
const defaultMessage = minDate => `Date should be greater than ${minDate}`;
export default (({
  message,
  format = defaultFormat,
  minDate = defaultMinDate(format)
} = {}) => value => {
  const date = moment(value, format, true);
  const min = moment(minDate, format, true);
  return min.diff(date) <= 0 ? null : message || defaultMessage(minDate);
});